import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Headphones, MessageCircle, Clock, HelpCircle, ArrowRight } from 'lucide-react';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const Support = () => {
  const navigate = useNavigate();

  const handleNavigation = (title) => {
    if (title === "Help Center") {
      navigate('/support/create-ticket');
    }
  };

  const supportOptions = [
    {
      icon: <HelpCircle size={24} />,
      title: "Help Center",
      description: "Browse our comprehensive knowledge base",
      color: "#F59E0B",
      available: "SELF-SERVICE RESOURCES",
      features: ["Documentation", "Video tutorials", "FAQ database"]
    },
    {
      icon: <MessageCircle size={24} />,
      title: "Live Chat",
      description: "Get instant help from our support team",
      color: "#3B82F6",
      available: "AVAILABLE 24/7",
      features: ["Instant messaging", "Real-time support", "Screen sharing"]
    }
  ];

  return (
    <>
      <PageBreadcrumb />

      <PageHeader
        title="Support Center"
        description="Get help with CAM360. Choose the support option that works best for you."
      />

      <div className="page-container">

        {/* CARDS */}
        <div
          className="grid-modern-3"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            width: '100%'
          }}
        >
          {supportOptions.map((option, index) => (
            <div
              key={index}
              className="asset-landing-card"
              style={{ cursor: 'pointer' }}
              onClick={() => handleNavigation(option.title)}
            >
              {/* TOP BORDER */}
              <div
                style={{
                  height: '4px',
                  background: 'var(--primary-color)',
                  width: '100%'
                }}
              />

              <div style={{ padding: '24px' }}>

                {/* HEADER */}
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: 'var(--radius-lg)',
                      background: `${option.color}20`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px'
                    }}
                  >
                    <div style={{ color: option.color }}>
                      {option.icon}
                    </div>
                  </div>

                  <div className="flex-grow-1">
                    <h4 style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      color: 'var(--text-primary)',
                      margin: 0,
                      fontFamily: 'var(--font-family)'
                    }}>
                      {option.title}
                    </h4>
                  </div>

                  <ArrowRight size={20} />
                </div>

                {/* DESCRIPTION */}
                <p style={{
                  fontSize: '13px',
                  color: 'var(--text-secondary)',
                  marginBottom: '12px',
                  fontFamily: 'var(--font-family)'
                }}>
                  {option.description}
                </p>

                {/* AVAILABLE */}
                <div style={{
                  fontSize: '11px',
                  fontWeight: '500',
                  color: option.color,
                  marginBottom: '6px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  {option.available}
                </div>

                {/* FEATURES */}
                <div>
                  <div style={{
                    fontSize: '11px',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '6px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>
                    KEY FEATURES
                  </div>

                  <div className="d-flex flex-wrap gap-1">
                    {option.features.map((feature, i) => (
                      <span
                        key={i}
                        style={{
                          fontSize: '11px',
                          padding: '3px 6px',
                          background: '#f3f4f6',
                          color: '#374151',
                          borderRadius: '4px',
                          fontWeight: '500'
                        }}
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>

        {/* ✅ NEED IMMEDIATE ASSISTANCE SECTION (FIXED) */}
        <div
          className="card-cam"
          style={{
            marginTop: '32px',
            maxWidth: '1200px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '16px'
          }}>
            <Headphones size={24} color="#EC4899" />

            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1F2937',
              margin: 0,
              fontFamily: 'var(--font-family)'
            }}>
              Need Immediate Assistance?
            </h3>
          </div>

          <p style={{
            fontSize: '14px',
            color: '#6B7280',
            marginBottom: '16px',
            fontFamily: 'var(--font-family)'
          }}>
            Our support team is here to help you get the most out of CAM360.
            Contact us through any of the channels above for personalized assistance.
          </p>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            color: '#6B7280',
            fontFamily: 'var(--font-family)'
          }}>
            <Clock size={16} />
            <span>Average response time: 2 hours</span>
          </div>
        </div>

      </div>
    </>
  );
};

export default Support;